import React from "react";

const brandlogoData = [
  {
    id: 1,
    image: "images/react64.png",
  },
  {
    id: 2,
    image: "images/node64.png",
  },
  {
    id: 3,
    image: "images/js64.png",
  },
  {
    id: 4,
    image: "images/laravel64.png",
  },
  {
    id: 5,
    image: "images/client-3.svg",
  },
  {
    id: 6,
    image: "images/client-6.svg",
  },
  {
    id: 7,
    image: "images/bootstrap.png",
  },
  {
    id: 8,
    image: "images/github.png",
  },
];

function Brandlogos() {
  return (
    <div id="branglogos">
      <div className="container">
        <div className="row">
          {brandlogoData.map((brandlogo) => (
            <div className="col-md-3 col-6" key={brandlogo.id}>
              <div className="client-item">
                <div className="inner">
                  <img src={brandlogo.image} alt="client-name" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Brandlogos;
